import { all, call, put, takeEvery } from 'redux-saga/effects';
import actions from './actions';
import { getRequest } from '../../../../helpers/axiosClient';

export function* getClassdetails(params) {

    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.UNITCLASS_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.UNITCLASS_DETAILS_FAILURE });
        return error;
    }
}

export function* getMesurementdetails(params) {

    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.UNITMESUREMENT_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.UNITMESUREMENT_DETAILS_FAILURE });
        return error;
    }
}


export function* getConversiondetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.UNITCONVERSION_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.UNITCONVERSION_DETAILS_FAILURE });
        return error;
    }
}

export function* getProductConversiondetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.PRODUCT_UNITCONVERSION_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PRODUCT_UNITCONVERSION_DETAILS_FAILURE });
        return error;
    }
}

export function* getProductGroupdetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.PRODUCT_GROUP_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PRODUCT_GROUP_DETAILS_FAILURE });
        return error;
    }
}

export function* getLocationdetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.LOCATION_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.LOCATION_DETAILS_FAILURE });
        return error;
    }
}

export function* getMaintainPriceDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.MAINTAIN_PRICE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension,
            exportType: params.exportType
        });
    } catch (error) {
        yield put({ type: actions.MAINTAIN_PRICE_DETAILS_FAILURE });
        return error;
    }
}

export function* getSalesDiscountDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.SALES_DISCOUNT_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension,
            exportType: params.exportType
        });
    } catch (error) {
        yield put({ type: actions.SALES_DISCOUNT_DETAILS_FAILURE });
        return error;
    }
}

export function* getPurchasePriceDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(params.url));
        }
        yield put({
            type: actions.PURCHASE_PRICE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension,
            exportType: params.exportType
        });
    } catch (error) {
        yield put({ type: actions.PURCHASE_PRICE_DETAILS_FAILURE });
        return error;
    }
}


export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_PRODUCT_DETAILS_SUCCESS,
    });
}

export default function* productSetupSaga() {
    yield all([
        takeEvery(actions.PRODUCT_GROUP_DETAILS_START, getProductGroupdetails),
        takeEvery(actions.LOCATION_DETAILS_START, getLocationdetails),
        takeEvery(actions.UNITCLASS_DETAILS_START, getClassdetails),
        takeEvery(actions.UNITMESUREMENT_DETAILS_START, getMesurementdetails),
        takeEvery(actions.UNITCONVERSION_DETAILS_START, getConversiondetails),
        takeEvery(actions.PRODUCT_UNITCONVERSION_DETAILS_START, getProductConversiondetails),
        takeEvery(actions.MAINTAIN_PRICE_DETAILS_START, getMaintainPriceDetails),
        takeEvery(actions.SALES_DISCOUNT_DETAILS_START, getSalesDiscountDetails),
        takeEvery(actions.PURCHASE_PRICE_DETAILS_START, getPurchasePriceDetails),
        takeEvery(actions.CLEAR_PRODUCT_DETAILS_START, getClearDetails)
    ])
}